module.exports = __webpack_public_path__ + "static/media/up.7350da71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.svg
// module id = 96
// module chunks = 0